import { render, staticRenderFns } from "./AppBottomNav.vue?vue&type=template&id=84222cec&scoped=true"
import script from "./AppBottomNav.vue?vue&type=script&lang=js"
export * from "./AppBottomNav.vue?vue&type=script&lang=js"
import style0 from "./AppBottomNav.vue?vue&type=style&index=0&id=84222cec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84222cec",
  null
  
)

export default component.exports